import type { TFunction } from 'i18next'

import type { TriagePriority } from './types'

/** Cor do selo de prioridade: P1 chama atenção, P2 avisa, P3 é neutro. */
export function priorityVariant(priority: TriagePriority | null): 'danger' | 'warning' | 'neutral' {
  switch (priority) {
    case 'P1':
      return 'danger'
    case 'P2':
      return 'warning'
    default:
      return 'neutral'
  }
}

/**
 * Idade compacta ("agora", "12 min", "3 h", "2 d") para "esperando há" / "última resposta há". Reusa os rótulos do
 * Desk para manter o vocabulário. `nowMs` é injetável para testes.
 */
export function formatAge(
  fromIso: string | null,
  t: TFunction,
  nowMs: number = Date.now(),
): string | null {
  if (fromIso === null) {
    return null
  }

  const from = new Date(fromIso).getTime()
  if (Number.isNaN(from)) {
    return null
  }

  const minutes = Math.max(0, Math.floor((nowMs - from) / 60_000))
  if (minutes < 1) {
    return t('desk.ticket.waitingNow')
  }

  if (minutes < 60) {
    return t('desk.ticket.waitingMinutes', { count: minutes })
  }

  const hours = Math.floor(minutes / 60)
  if (hours < 24) {
    return t('desk.ticket.waitingHours', { count: hours })
  }

  return t('desk.ticket.waitingDays', { count: Math.floor(hours / 24) })
}
